import styled from "styled-components";
import { theme } from '../../../theme'

export const StyledSubjectBannerDiv = styled.div`
    /* background-color: ${theme.colors.green};
    background-image: url('/assets/images/subject/subject_mathematics.png'); */
    position: relative;
    height: 24.2rem;
    margin-bottom: 4rem;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0293252);
    border-radius: 11px;
    color: ${theme.colors.white};

    .overlay-content {
        text-align: center;
        .banner-subject-title {
            font-weight: 700;
            font-size: 2.7rem;
        }
        .banner-subject-info {
            display: flex;
            align-items:center;
            font-size: 1.2rem;
            font-weight: 500;
            justify-content: center;
            margin-top: 1rem;

            svg {
                width: 1.6rem;
                height: 1.6rem;
                margin-right: 5px;
            }

            .banner-subject-info-item {
                display: flex;
                align-items:center;

                &.banner-subject-topics {
                    margin-left: 1.2rem;
                }
            }
        }
    }

    .banner-subject-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 11px;
    }
`
export const StyledBannerOverlay = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: ${theme.colors.green};
    border-radius: 8px 6px 0px 0px;
    z-index: 2;
    display: flex;
    align-items:center;
    justify-content: center;
    border-radius: 11px;
`

export const StyledNextButton = styled.div`
    position: absolute;
    top: 50%;
    right: 0;
    background-color: ${theme.colors.white};
    border-radius: 50%;
    z-index: 3;
    cursor: pointer;
    display: flex;
    align-items:center;
    justify-content: center;
    width: 3.4rem;
    height: 3.4rem;
    transform: translate(50%, -50%);
    color: #565B73;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

    svg {
        width: 15px;
        height: 15px;
    }
`